const tagStyles = theme => ({
  '.tag': {
    padding: '4px 8px',
    border: `1px solid ${theme('colors.grey.40')}`,
    borderRadius: '4px',
    background: theme('colors.white'),
  },
});

module.exports = { tagStyles };
